import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CurrentMeetService } from '../../shared/services/current-meet.service';
import { CurrentTimezoneModel } from '../../shared/models/current-timezone.model';
import { Observable } from 'rxjs';
import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { DateTime } from 'luxon';
import { AliveDatePipe } from '../../shared/pipes/alive-date.pipe';

@Component({
  selector: 'app-event-date',
  imports: [AsyncPipe, AliveDatePipe, NgTemplateOutlet],
  templateUrl: './event-date.component.html',
  styleUrl: './event-date.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class EventDateComponent {
  @Input() meetDates!: string[];
  @Input() date!: string;
  @Input() heatDates:
    | {
        heatNumber: number[];
        name: string;
        date: string;
      }[]
    | null = null;
  currentTimezone$!: Observable<CurrentTimezoneModel | null>;

  constructor(public currentMeetService: CurrentMeetService) {
    this.currentTimezone$ = this.currentMeetService.updateCurrentTimezone;
  }

  protected readonly DateTime = DateTime;
}
